import { render, staticRenderFns } from "./FooterDrop.vue?vue&type=template&id=b06d28a6&scoped=true&"
var script = {}
import style0 from "./FooterDrop.vue?vue&type=style&index=0&id=b06d28a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06d28a6",
  null
  
)

export default component.exports